import React, { useEffect } from "react";
import { Provider } from "react-redux";
import localeData from "dayjs/plugin/localeData";
import dayjs from "dayjs";
import "./index.scss";

import { config } from "@triare/auth-redux";

import store from "./store";
import Routes from "./routes";
import AntdConfigProvider from "./AntdConfigProvider";

const { displayName } = config;

dayjs.extend(localeData);

export default function App(): React.ReactNode {
  useEffect(() => {
    document.title = `${displayName}: Sign in`;
  }, []);

  return (
    <Provider store={store}>
      <AntdConfigProvider>
        <Routes />
      </AntdConfigProvider>
    </Provider>
  );
}
